module.exports = __webpack_public_path__ + "assets/img/btn-download-steam-dc7cd234.png";